import portalProveedoresApi from '../api/portalProveedoresApi'
import authHeader from '../services/auth-header'

const sendFactura = async (FacturaNameFile, FacturaFile, Metadatos) => {
  try {
    const { data } = await portalProveedoresApi.post('/SendFactura', { Email: localStorage.getItem('email'), FacturaNameFile, FacturaFile, Metadatos }, { headers: authHeader() })
    console.log('Recibidos datos' + data)
    console.log('metadatos' + Metadatos)
    console.log('name' + FacturaNameFile)
    return data
  } catch (error) {
    console.log(error)
    return null
  }
}

export default sendFactura
